import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { CreateContractCommandHandler } from './create-contract-command-handler.service';
import { vacantRentalObjectCommand } from '../../model/const/command';
import { VacantDwellingExportCommandHandler } from './vacant-dwelling-export-command-handler.service';
import { CreateBlockContractRentalObjectCommandHandler } from './create-blockcontract-rental-object-command-handler.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { AdvertiseRentalObjectCommandHandler } from './advertise-rental-object-command-handler.service';

@Injectable()
export class VacantCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    createContractHandler: CreateContractCommandHandler,
    createBlockContractHandler: CreateBlockContractRentalObjectCommandHandler,
    exportToExcelHandler: VacantDwellingExportCommandHandler,
    advertiseHandler: AdvertiseRentalObjectCommandHandler
  ) {
    super();
    this.addHandler(rentalObjectCommand.advertise, advertiseHandler);
    this.addHandler(vacantRentalObjectCommand.createContract, createContractHandler);
    this.addHandler(vacantRentalObjectCommand.createBlockContract, createBlockContractHandler);
    this.addHandler(vacantRentalObjectCommand.exportToExcel, exportToExcelHandler);
  }
}
